import script from "./DebriefFast.vue?vue&type=script&setup=true&lang=js"
export * from "./DebriefFast.vue?vue&type=script&setup=true&lang=js"

import "./DebriefFast.vue?vue&type=style&index=0&id=4f18dd41&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/ignis-front-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f18dd41"]])

export default __exports__